import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

function AddWidget(props: Readonly<SvgIconProps & { disabled?: boolean }>): JSX.Element {
    return (
        <SvgIcon viewBox='0 -960 960 960' {...props}>
            <path
                d='M120-840h320v320H120v-320Zm80 80v160-160Zm320-80h320v320H520v-320Zm80 80v160-160ZM120-440h320v320H120v-320Zm80 80v160-160Zm440-80h80v120h120v80H720v120h-80v-120H520v-80h120v-120Zm-40-320v160h160v-160H600Zm-400 0v160h160v-160H200Zm0 400v160h160v-160H200Z'
                fill={props.disabled ? '#AAAAAA' : '#000000'}
                className={props.className}
            />
        </SvgIcon>
    );
}

export default React.memo(AddWidget);
